export default __webpack_public_path__ + "static/media/Handbuch-Piktogramm_eIFU.63cc2ca5.svg";